// removed by extract-text-webpack-plugin
module.exports = {"container":"pages-post-container","content":"pages-post-content","cols":"pages-post-cols","colDate":"pages-post-colDate","colContent":"pages-post-colContent","header":"pages-post-header","title":"pages-post-title","section":"pages-post-section","col":"pages-post-col","inner":"pages-post-inner","date":"pages-post-date","number":"pages-post-number","month":"pages-post-month","year":"pages-post-year","social":"pages-post-social","block":"pages-post-block"};


//////////////////
// WEBPACK FOOTER
// ./styles/pages/post.scss
// module id = 878
// module chunks = 246